import React, {useEffect, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import EmployerService from "../../../services/EmployerService";
import PolicyHoldersService from "../../../services/PolicyHoldersService";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputMask from 'react-input-mask';
import Spinner from "reactjs-simple-spinner";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';
import moment from 'moment';
import {MenuItem, TextField} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 250,
    },
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));



const AddPolicyHolder = (props) => {


    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setPolicyHolder({});
        setActiveStep(0);
    };
    const [maximumDate, setMaximumDate] = useState(null);

//    initialize variables
    const [policyHolder, setPolicyHolder] = useState({
        "title": "",
        "first_name": "",
        "last_name": "",
        "date_of_birth": "",
        "id_number": "",
        "gender": "",
        "work_telephone": "",
        "mobile": "",
        "email": "",
        "ec_number": "",
        "aggregator_id": "",
        "occupation": "",
        "smoker_status": "",
        "salary": "",
        "status": "",
        "physical_address_city": "",
        "physical_address_street": "",
        "physical_address_suburb": "",
        "postal_address_city": "",
        "postal_address_street": "",
        "postal_address_suburb": "",
    });

    //address details
    const [physicalAddress, setPhysicalAddress] = useState({street: '', suburb: '', city: ''});
    const [isSame, setIsSame] = useState(false);
    const [postalAddress, setPostalAddress] = useState({});
    const [postalStreet, setPostalStreet] = useState();
    const [postalSuburb, setPostalSuburb] = useState();
    const [postalCity, setPostalCity] = useState();
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [initLoading, setInitLoading] = useState(false);
    const [birthDate, setBirthDate] = useState({year: '', month: '', day: ''});
    //aggregators
    const [aggregators, setAggregators] = useState([]);
    const [date, setDate] = useState('');
    const [data, setData] = useState([])


    useEffect(() => {
        setInitLoading(true);

        setLoading(false);

        let date = moment().subtract(18, "years")
        const defaultValue = {
            year: date.year(),
            month: date.month() + 1,
            day: date.date()
        };
        setBirthDate(defaultValue)
        setMaximumDate(defaultValue);
        let allowedAge = new Date();
        allowedAge.setFullYear(allowedAge.getFullYear() - 18);
        const a = allowedAge.toISOString().slice(0, 10);
        const disabledDates = "'" + a + "'";
        setDate(disabledDates);
        console.log(disabledDates);


        //setPolicyHolder({});
        setMessage('');
        setIsSame(false);
        setReadOnly(false);
        EmployerService.getAllEmployers().then(response => {

            if (response == null) {
                setAggregators([]);
                setInitLoading(false)
            }
            console.log('Employer', response);
            setAggregators(response);
            setInitLoading(false)
        }).catch(err => {
            setAggregators([]);
            console.log(err);
            setInitLoading(false)
        });


    }, [])

    const classes = useStyles();

    //validation functions
    const [errorMessage, setErrorMessage] = useState('');
    const [errMsg, setErrMsg] = useState(false)
    const required = (value) => {
        if (!value) {
            setErrorMessage('Required');
        }
    }

    const [readOnly, setReadOnly] = useState(false);
    const autoPopulate = (e) => {
        console.log(e.target.value);
        if (e.target.value === 'yes') {

            if (Object.keys(physicalAddress).length === 0) {
                setIsSame(false);
                setReadOnly(false);
                setMessage('Fill in the above details first');
                console.log(isSame + ' msg: ' + message);
            } else {
                if (physicalAddress.street === '' || physicalAddress.suburb === '' || physicalAddress.city === ''
                    || physicalAddress.street === undefined
                    || physicalAddress.suburb === undefined || physicalAddress.city === undefined) {
                    setIsSame(false);
                    setReadOnly(false);
                    setMessage('Fill in the above details first');
                    console.log(isSame + ' msg: ' + message);
                } else {
                    setIsSame(true);
                    setReadOnly(true);
                    setMessage('');
                    console.log("phys", physicalAddress);
                    setPostalAddress({
                        ...postalAddress,
                        "street": physicalAddress.street,
                        "suburb": physicalAddress.suburb,
                        "city": physicalAddress.city
                    });

                    //display on page
                    setPostalCity(physicalAddress.city);
                    setPostalStreet(physicalAddress.street);
                    setPostalSuburb(physicalAddress.suburb);

                    setPolicyHolder({
                        ...policyHolder,
                        "postal_address_city": physicalAddress.city,
                        "postal_address_street": physicalAddress.street,
                        "postal_address_suburb": physicalAddress.suburb,
                    });

                }
            }

        } else {
            setIsSame(false);
            setReadOnly(false);
            setMessage('');
            setPostalAddress({...postalAddress, street: "", city: "", suburb: ""});

            setPolicyHolder({
                ...policyHolder, "postal_address_city": postalAddress.city,
                "postal_address_street": postalAddress.street,
                "postal_address_suburb": postalAddress.suburb
            });
            console.log(policyHolder);
        }
    }

    const handleChangePhysicalAddress = name => ({target: {value}}) => {
        setPhysicalAddress({...physicalAddress, [name]: value})

        if (name === 'city') {
            setPolicyHolder({
                ...policyHolder,
                "physical_address_city": value,
            });
        }
        if (name === 'street') {
            setPolicyHolder({
                ...policyHolder,
                "physical_address_street": value,
            });
        }

        if (name === 'suburb') {
            setPolicyHolder({
                ...policyHolder,
                "physical_address_suburb": value,
                'clientType': 'SSB'
            });
        }


        console.log(policyHolder);
    }

    const handleChangePostalAddress = name => ({target: {value}}) => {
        setPostalAddress({...postalAddress, [name]: value})

        if (name === 'city') {
            setPolicyHolder({
                ...policyHolder,
                "postal_address_city": value,
            });
        }

        if (name === 'street') {
            setPolicyHolder({
                ...policyHolder,
                "postal_address_street": value,
            });
        }

        if (name === 'suburb') {
            setPolicyHolder({
                ...policyHolder,
                "postal_address_suburb": value,
            });
        }

        console.log(policyHolder);
    }

    const handleChange = name => ({target: {value}}) => {
        if (name === 'id_number') {
            const found = data.find(d => d.id_number == value)
            console.log('found outside: ', found)
            if (found) {
                setErrMsg(true);
                console.log('found inside: ', found)
            } else {
                setErrMsg(false)
                setPolicyHolder({...policyHolder, [name]: value})
                console.log(policyHolder)
            }

        } else {
            setPolicyHolder({...policyHolder, [name]: value})
        }

    }


    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);

        //injury date
        if (birthDate.month < 10 && birthDate.day > 10) {

            policyHolder.date_of_birth = birthDate.year + '-0' + birthDate.month + '-' + birthDate.day
            setPolicyHolder({
                ...policyHolder,
                "date_of_birth": policyHolder.date_of_birth
            });
        } else if (birthDate.day < 10 && birthDate.month > 10) {

            policyHolder.date_of_birth = birthDate.year + '-' + birthDate.month + '-0' + birthDate.day
            setPolicyHolder({
                ...policyHolder,
                "date_of_birth": policyHolder.date_of_birth
            });

        } else if (birthDate.day < 10 && birthDate.month < 10) {

            policyHolder.date_of_birth = birthDate.year + '-0' + birthDate.month + '-0' + birthDate.day
            setPolicyHolder({
                ...policyHolder,
                "date_of_birth": policyHolder.date_of_birth
            });

        } else {

            policyHolder.date_of_birth = birthDate.year + '-' + birthDate.month + '-' + birthDate.day;
            setPolicyHolder({
                ...policyHolder,
                "date_of_birth": policyHolder.date_of_birth,
            });
        }

        console.log("post data: ", policyHolder);
        //post data
        PolicyHoldersService.savePolicyHolder(policyHolder)
            .then(res => {
                console.log('res: ', res);
                if (res.status === 200) {
                    //setPolicyHolder to asyncStorage
                    localStorage.setItem('policyHolder', JSON.stringify(res.data));
                    localStorage.setItem('policyHolderId', JSON.stringify(res.data.id));
                    localStorage.setItem("pHolder", JSON.stringify(res.data));
                    //redirect to allocate policy
                    setLoading(false);
                    props.history.push('/allocate-policy');
                } else if (res.status === 422) {
                    toast.error(res.data.message);
                    setLoading(false);
                } else {
                    setLoading(false);
                    toast.warning('Network Error, Try again \nIf error persists contact System Administrator ');
                }
            })
            .catch(err => {
                setLoading(false);
                toast.warning('Network Error, Try again \nIf error persists contact System Administrator ');
                console.log('err: ', err);
            });

    }


    function getSteps() {
        return ['Personal Details', 'Aggregator Details', 'Address'];
    }

    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        <div className="row">
                            <div className="form-group col-md-3" style={{marginTop: -8}}>
                                <label style={{marginTop: -3}}>Title</label>
                                <TextField
                                    // className="form-control"
                                    name="title"
                                    required

                                    select
                                    fullWidth
                                    validations={[required]}
                                    onChange={handleChange('title')}
                                >
                                    {policyHolder.title !== '' && (
                                        <MenuItem selected={true} value={policyHolder.title}>
                                            {policyHolder.title}
                                        </MenuItem>
                                    )}
                                    <MenuItem disabled={true} value>Select Title</MenuItem>
                                    <MenuItem value="MR">Mr</MenuItem>
                                    <MenuItem value="MRS">Mrs</MenuItem>
                                    <MenuItem value="DR">Dr</MenuItem>
                                    <MenuItem value="MISS">Miss</MenuItem>
                                    <MenuItem value="MS">Ms</MenuItem>
                                    <MenuItem value="PROF">Prof</MenuItem>
                                    <MenuItem value="ENG">Eng</MenuItem>
                                </TextField>
                                <p className="message">
                                    {/*{{ validation.firstError("title") }}*/}
                                </p>
                            </div>
                            <div className="form-group col-md-3">
                                <TextField
                                    type="text"
                                    autoComplete="off"
                                    aria-autocomplete={false}
                                    // className="form-control"
                                    label="First Name"
                                    fullWidth
                                    required
                                    value={policyHolder.first_name}
                                    name="first_name"
                                    validations={[required]}
                                    onChange={handleChange('first_name')}
                                />
                                <p className="message">
                                    {/*{{ validation.firstError("first_name") }}*/}
                                </p>
                            </div>

                            <div className="form-group col-md-3">
                                <TextField
                                    type="text"
                                    autoComplete="off"
                                    // className="form-control"
                                    label="Last Name"
                                    fullWidth
                                    name="last_name"
                                    value={policyHolder.last_name}
                                    validations={[required]}
                                    required
                                    onChange={handleChange('last_name')}
                                />
                                <p className="message">
                                    {/*{{ validation.firstError("last_name") }}*/}
                                </p>
                            </div>
                            <div className="form-group col-md-3" style={{marginTop: -8}}>
                                <label style={{marginTop: -3}}>Marital Status</label>
                                <TextField select
                                           onChange={handleChange('status')}
                                           name="status"
                                           fullWidth
                                           required>
                                    {policyHolder.status !== '' && (
                                        <MenuItem selected={true} value={policyHolder.status}>
                                            {policyHolder.status}
                                        </MenuItem>
                                    )}
                                    <MenuItem value disabled={true}>Select Marital Status</MenuItem>
                                    <MenuItem value="Single">Single</MenuItem>
                                    <MenuItem value="Married">Married</MenuItem>
                                    <MenuItem value="Divorced">Divorced</MenuItem>
                                    <MenuItem value="Widowed">Widowed</MenuItem>
                                </TextField>
                                <p className="message">
                                    {/*{{ validation.firstError("gender") }}*/}
                                </p>
                            </div>
                            <div className="form-group col-md-3" style={{marginTop: -8}}>
                                <label>Gender</label>
                                <TextField
                                    onChange={handleChange('gender')}
                                    name="gender"
                                    fullWidth
                                    select
                                    required>
                                    {policyHolder.gender !== '' && (
                                        <MenuItem selected={true} value={policyHolder.gender}>
                                            {policyHolder.gender}
                                        </MenuItem>
                                    )}
                                    <MenuItem disabled={true} value>Select Gender</MenuItem>
                                    <MenuItem value="Male">MALE</MenuItem>
                                    <MenuItem value="Female">FEMALE</MenuItem>
                                </TextField>
                                <p className="message">
                                    {/*{{ validation.firstError("gender") }}*/}
                                </p>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-12"/>

                            <div className="form-group col-md-3">
                                <label>Mobile Number</label>
                                <InputMask mask="0999999999"
                                           value={policyHolder.mobile}
                                           required
                                           className="form-control" maskChar={null} name="mobile"
                                           onChange={handleChange('mobile')}/>

                            </div>

                            <div className="form-group col-md-3">
                                <label>Alternative Number</label>
                                <InputMask mask="0999999999"
                                           required
                                           value={policyHolder.work_telephone}
                                           className="form-control"
                                           maskChar={null}
                                           name="work_telephone"
                                           onChange={handleChange('work_telephone')}
                                />

                            </div>

                            <div className="form-group col-md-3">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={policyHolder.email}
                                    onChange={handleChange('email')}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>Occupation</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="occupation"
                                    value={policyHolder.occupation}
                                    required
                                    onChange={handleChange('occupation')}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-12"/>

                            <div className="form-group col-md-3">
                                <label>Date of Birth</label>
                                <br/>
                                <DatePicker
                                    value={birthDate}
                                    onChange={setBirthDate}
                                    maximumDate={maximumDate}
                                    inputPlaceholder="Select Birth Date"
                                    shouldHighlightWeekends
                                />

                                <p className="message">
                                    {/*{{ validation.firstError("date_of_birth") }}*/}
                                </p>
                            </div>

                            <div className="form-group col-md-3">
                                <label>ID Number&nbsp;&nbsp;
                                    <span className="text-black-50 muted">(000000000J00)</span>
                                </label>
                                <InputMask mask='99999999**99'
                                           className="form-control"
                                           maskChar=" "
                                           value={policyHolder.id_number}
                                           required
                                           name="id_number"
                                           validations={[required]}
                                           onChange={handleChange('id_number')}
                                />
                                {errMsg && (
                                    <Alert severity="error">This id number is already in use!</Alert>
                                )}

                            </div>

                            <div className="form-group col-md-3">
                                <label>EC Number</label>
                                <input

                                    value={policyHolder.ec_number}
                                    className="form-control"
                                    name="ec_number"
                                    onChange={handleChange('ec_number')}
                                    type="text"
                                    autoComplete="off"

                                />

                            </div>


                            <div className="form-group col-md-3" style={{marginTop: -8}}>
                                <label>Smokers Status</label>
                                <TextField
                                    onChange={handleChange('smoker_status')}
                                    name="smoker_status"
                                    select
                                    fullWidth
                                    required>
                                    {policyHolder.smoker_status !== '' && (
                                        <MenuItem selected={true} value={policyHolder.smoker_status}>
                                            {policyHolder.smoker_status}
                                        </MenuItem>
                                    )}
                                    <MenuItem value disabled={true}>Select Option</MenuItem>
                                    <MenuItem value="Current Smoker">Current Smoker</MenuItem>
                                    <MenuItem value="Former Smoker">Former Smoker</MenuItem>
                                    <MenuItem value="Never Smoked">Never Smoked</MenuItem>
                                </TextField>

                                <p className="message">
                                    {/*{{ validation.firstError("gender") }}*/}
                                </p>
                            </div>


                            <div className="form-group col-md-3">
                                <label>Salary</label>
                                <input

                                    value={policyHolder.salary}
                                    className="form-control"

                                    name="salary"
                                    onChange={handleChange('salary')}
                                    type="text"
                                    autoComplete="off"

                                />

                            </div>


                        </div>
                    </div>
                );
            case 1:
                return (
                    <div>
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label>
                                    <strong>AGGREGATOR DETAILS</strong>
                                </label>
                            </div>

                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-12"/>
                            <div className="form-group col-md-4">
                                <label>Aggregator Name</label>

                                <TextField
                                    fullWidth
                                    onChange={handleChange('aggregator_id')}
                                    name="aggregator_id"
                                    select
                                >
                                    <MenuItem value disabled={true}>Select Aggregator</MenuItem>
                                    {aggregators.map((aggr, i) => {
                                        return (
                                            <MenuItem key={i} value={aggr.id}>{aggr.id}:{aggr.name}</MenuItem>

                                        )
                                    })}
                                </TextField>

                            </div>

                        </div>
                    </div>
                );
            case 2:
                return (
                    <div>
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label>
                                    <strong>RESIDENTIAL ADDRESS</strong>
                                </label>
                            </div>
                            <div className="form-group col-md-4">
                                <label>Street</label>
                                <input
                                    type="text"
                                    required
                                    className="form-control"
                                    name="street"
                                    value={physicalAddress.street}
                                    autoComplete="off"
                                    readOnly={readOnly}
                                    onChange={handleChangePhysicalAddress('street')}
                                />
                                <p className="message">
                                    {/*{{ validation.firstError("street") }}*/}
                                </p>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Suburb</label>
                                <input
                                    type="text"
                                    required
                                    autoComplete="off"
                                    className="form-control"
                                    value={physicalAddress.suburb}
                                    name="suburb"
                                    readOnly={readOnly}
                                    onChange={handleChangePhysicalAddress('suburb')}
                                />
                                <p className="message">
                                    {/*{{ validation.firstError("suburb") }}*/}
                                </p>
                            </div>
                            <div className="form-group col-md-4">
                                <label>City</label>
                                <TextField
                                    onChange={handleChangePhysicalAddress('city')}
                                    name="city"
                                    select
                                    readOnly={readOnly}
                                    fullWidth
                                    required>
                                    {physicalAddress.city !== '' && (
                                        <MenuItem selected={true} value={physicalAddress.city}>
                                            {physicalAddress.city}
                                        </MenuItem>
                                    )}
                                    <MenuItem value disabled={true}>Select City</MenuItem>
                                    <MenuItem value="Arcturus">Arcturus</MenuItem>
                                    <MenuItem value="Banket">Banket</MenuItem>
                                    <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                                    <MenuItem value="Bindura">Bindura</MenuItem>
                                    <MenuItem value="Buhera">Buhera</MenuItem>
                                    <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                                    <MenuItem value="Chegutu">Chegutu</MenuItem>
                                    <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                                    <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                                    <MenuItem value="Chipinge">Chipinge</MenuItem>
                                    <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                                    <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                                    <MenuItem value="Chivhu">Chivhu</MenuItem>
                                    <MenuItem value="Darwendale">Darwendale</MenuItem>
                                    <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                                    <MenuItem value="Guruve">Guruve</MenuItem>
                                    <MenuItem value="Gwanda">Gwanda</MenuItem>
                                    <MenuItem value="Gweru">Gweru</MenuItem>
                                    <MenuItem value="Harare">Harare</MenuItem>
                                    <MenuItem value="Hwange">Hwange</MenuItem>
                                    <MenuItem value="Kadoma">Kadoma</MenuItem>
                                    <MenuItem value="Kariba">Kariba</MenuItem>
                                    <MenuItem value="Karoi">Karoi</MenuItem>
                                    <MenuItem value="Kezi">Kezi</MenuItem>
                                    <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                                    <MenuItem value="Lupane">Lupane</MenuItem>
                                    <MenuItem value="Marondera">Marondera</MenuItem>
                                    <MenuItem value="Masvingo">Masvingo</MenuItem>
                                    <MenuItem value="Mazoe">Mazoe</MenuItem>
                                    <MenuItem value="Mhangura">Mhangura</MenuItem>
                                    <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                                    <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                                    <MenuItem value="Murehwa">Murehwa</MenuItem>
                                    <MenuItem value="Mutare">Mutare</MenuItem>
                                    <MenuItem value="Mutoko">Mutoko</MenuItem>
                                    <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                                    <MenuItem value="Norton">Norton</MenuItem>
                                    <MenuItem value="Nyanga">Nyanga</MenuItem>
                                    <MenuItem value="Plumtree">Plumtree</MenuItem>
                                    <MenuItem value="Redcliff">Redcliff</MenuItem>
                                    <MenuItem value="Rusape">Rusape</MenuItem>
                                    <MenuItem value="Ruwa">Ruwa</MenuItem>
                                    <MenuItem value="Sakubva">Sakubva</MenuItem>
                                    <MenuItem value="Shamva">Shamva</MenuItem>
                                    <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                                    <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                                    <MenuItem value="Zvishavane">Zvishavane</MenuItem>

                                </TextField>

                                <p className="message">
                                    {/*{{ validation.firstError("city") }}*/}
                                </p>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-6"
                                 onChange={autoPopulate}>
                                <label>Is Physical Address Same As Postal Address</label>
                                <br/>
                                <input
                                    type="radio"
                                    name="isSame"
                                    value="yes"
                                    checked={isSame === true}
                                />
                                <label className="form-check-label ml-1 mr-3">Yes</label>
                                <input
                                    type="radio"
                                    name="isSame"
                                    value="no"
                                    checked={isSame === false}
                                />
                                <label className="form-check-label ml-1 mr-3">No</label>
                            </div>
                        </div>
                        {message && (
                            <div className="form-row">
                                <label><span className="text-danger">{message}</span></label>
                            </div>
                        )}

                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label>
                                    <strong>POSTAL ADDRESS</strong>
                                    <br/>
                                </label>

                                <br/>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Street</label>
                                <input
                                    type="text"
                                    value={postalAddress.street}
                                    className="form-control"
                                    required
                                    name="postalStreet"
                                    readOnly={readOnly}
                                    onChange={handleChangePostalAddress('street')}
                                />
                                <p className="message">
                                    {/*{{ validation.firstError("postal_street") }}*/}
                                </p>
                            </div>

                            <div className="form-group col-md-4">
                                <label>Suburb</label>
                                <input
                                    type="text"
                                    value={postalAddress.suburb}
                                    className="form-control"
                                    required
                                    name="postalSuburb"
                                    readOnly={readOnly}
                                    onChange={handleChangePostalAddress('suburb')}
                                />
                                <p className="message">
                                    {/*{{ validation.firstError("postal_suburb") }}*/}
                                </p>
                            </div>
                            <div className="form-group col-md-4">
                                <label>City</label>
                                <TextField
                                    onChange={handleChangePostalAddress('city')}
                                    name="postalCity"
                                    select
                                    readOnly={readOnly}
                                    fullWidth
                                    required>
                                    {postalAddress.city !== '' && (
                                        <MenuItem selected={true} value={postalAddress.city}>
                                            {postalAddress.city}
                                        </MenuItem>
                                    )}
                                    <MenuItem value disabled={true}>Select City</MenuItem>
                                    <MenuItem value="Arcturus">Arcturus</MenuItem>
                                    <MenuItem value="Banket">Banket</MenuItem>
                                    <MenuItem value="Beitbridge">Beitbridge</MenuItem>
                                    <MenuItem value="Bindura">Bindura</MenuItem>
                                    <MenuItem value="Buhera">Buhera</MenuItem>
                                    <MenuItem value="Bulawayo">Bulawayo</MenuItem>
                                    <MenuItem value="Chegutu">Chegutu</MenuItem>
                                    <MenuItem value="Chimanimani">Chimanimani</MenuItem>
                                    <MenuItem value="Chinhoyi">Chinhoyi</MenuItem>
                                    <MenuItem value="Chipinge">Chipinge</MenuItem>
                                    <MenuItem value="Chiredzi">Chiredzi</MenuItem>
                                    <MenuItem value="Chitungwiza">Chitungwiza</MenuItem>
                                    <MenuItem value="Chivhu">Chivhu</MenuItem>
                                    <MenuItem value="Darwendale">Darwendale</MenuItem>
                                    <MenuItem value="Goromonzi">Goromonzi</MenuItem>
                                    <MenuItem value="Guruve">Guruve</MenuItem>
                                    <MenuItem value="Gwanda">Gwanda</MenuItem>
                                    <MenuItem value="Gweru">Gweru</MenuItem>
                                    <MenuItem value="Harare">Harare</MenuItem>
                                    <MenuItem value="Hwange">Hwange</MenuItem>
                                    <MenuItem value="Kadoma">Kadoma</MenuItem>
                                    <MenuItem value="Kariba">Kariba</MenuItem>
                                    <MenuItem value="Karoi">Karoi</MenuItem>
                                    <MenuItem value="Kezi">Kezi</MenuItem>
                                    <MenuItem value="Kwekwe">Kwekwe</MenuItem>
                                    <MenuItem value="Lupane">Lupane</MenuItem>
                                    <MenuItem value="Marondera">Marondera</MenuItem>
                                    <MenuItem value="Masvingo">Masvingo</MenuItem>
                                    <MenuItem value="Mazoe">Mazoe</MenuItem>
                                    <MenuItem value="Mhangura">Mhangura</MenuItem>
                                    <MenuItem value="Mount Darwin">Mount Darwin</MenuItem>
                                    <MenuItem value="Mukumbura">Mukumbura</MenuItem>
                                    <MenuItem value="Murehwa">Murehwa</MenuItem>
                                    <MenuItem value="Mutare">Mutare</MenuItem>
                                    <MenuItem value="Mutoko">Mutoko</MenuItem>
                                    <MenuItem value="Mvurwi">Mvurwi</MenuItem>
                                    <MenuItem value="Norton">Norton</MenuItem>
                                    <MenuItem value="Nyanga">Nyanga</MenuItem>
                                    <MenuItem value="Plumtree">Plumtree</MenuItem>
                                    <MenuItem value="Redcliff">Redcliff</MenuItem>
                                    <MenuItem value="Rusape">Rusape</MenuItem>
                                    <MenuItem value="Ruwa">Ruwa</MenuItem>
                                    <MenuItem value="Sakubva">Sakubva</MenuItem>
                                    <MenuItem value="Shamva">Shamva</MenuItem>
                                    <MenuItem value="Shurugwi">Shurugwi</MenuItem>
                                    <MenuItem value="Victoria Falls">Victoria Falls</MenuItem>
                                    <MenuItem value="Zvishavane">Zvishavane</MenuItem>

                                </TextField>
                                <p className="message">
                                    {/*{{ validation.firstError("postal_city") }}*/}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            default:
                return 'Unknown step';
        }
    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/policy-holders"><a href><i className="fa fa-address-card"/>Leads</a> |
                            </Link
                            >
                            New Lead
                        </ul>

                        <div className="row">
                            <div className="col-lg-8">
                                <div className="card">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {initLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Preparing Form, Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && !initLoading && (
                                        <form id="policyholderData" onSubmit={handleSave} autoComplete="off">
                                            <div id="form-style">
                                                <h4>Create Policy Holder</h4>
                                                <div className="row mt">
                                                    <div className="col-lg-12">
                                                        <div className={classes.root}>
                                                            <Stepper activeStep={activeStep} orientation="vertical">
                                                                {steps.map((label, index) => (
                                                                    <Step key={label}>
                                                                        <StepLabel>{label}</StepLabel>
                                                                        <StepContent>
                                                                            <Typography>{getStepContent(index)}</Typography>
                                                                            <div className={classes.actionsContainer}>
                                                                                <div>
                                                                                    <Button
                                                                                        disabled={activeStep === 0}
                                                                                        onClick={handleBack}
                                                                                        className="btn btn-secondary"
                                                                                    >
                                                                                        Back
                                                                                    </Button>
                                                                                    {activeStep === steps.length - 1 ? (
                                                                                        <Button variant="contained"
                                                                                                color="primary"
                                                                                                onClick={handleSave}
                                                                                                className="btn btn-primary">
                                                                                            Submit
                                                                                        </Button>
                                                                                    ) : (
                                                                                        <Button variant="contained"
                                                                                                color="primary"
                                                                                                onClick={handleNext}
                                                                                                className="btn btn-primary">
                                                                                            Next
                                                                                        </Button>
                                                                                    )}

                                                                                </div>
                                                                            </div>
                                                                        </StepContent>
                                                                    </Step>
                                                                ))}
                                                            </Stepper>
                                                            {activeStep === steps.length && (
                                                                <Paper square elevation={0}
                                                                       className={classes.resetContainer}>
                                                                    <Typography>All steps completed - you&apos;re
                                                                        finished</Typography>
                                                                    <Button onClick={handleReset}
                                                                            className={classes.button}>
                                                                        Reset Form
                                                                    </Button>
                                                                </Paper>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="card">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && (
                                        <div id="form-style p-2">
                                            <h4 className="p-2">Track: Policy Holder</h4>
                                            <div className="row mt">

                                                <div className="col-lg-12">
                                                    <div className={classes.root}>
                                                        <div className="row p-2">
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Title"
                                                                    fullWidth
                                                                    value={policyHolder.title}
                                                                    name="first_name"
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="First Name"
                                                                    fullWidth
                                                                    value={policyHolder.first_name}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Last Name"
                                                                    fullWidth
                                                                    value={policyHolder.last_name}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Id Number"
                                                                    fullWidth
                                                                    value={policyHolder.id_number}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row p-2 mt">
                                                            <div className="form-group col-md-5">
                                                                <TextField
                                                                    type="text"
                                                                    label="Email"
                                                                    fullWidth
                                                                    value={policyHolder.email}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-2">
                                                                <TextField
                                                                    type="text"
                                                                    label="Gender"
                                                                    fullWidth
                                                                    value={policyHolder.gender}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Occupation"
                                                                    fullWidth
                                                                    value={policyHolder.occupation}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-2">
                                                                <TextField
                                                                    type="text"
                                                                    label="Salary"
                                                                    fullWidth
                                                                    value={policyHolder.salary}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row p-2 mt">
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="D.O.B"
                                                                    fullWidth
                                                                    value={birthDate.year + "/" + birthDate.month + "/" + birthDate.day}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Mobile"
                                                                    fullWidth
                                                                    value={policyHolder.mobile}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Alternative"
                                                                    fullWidth
                                                                    value={policyHolder.work_telephone}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="EC Number"
                                                                    fullWidth
                                                                    value={policyHolder.ec_number}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row p-2 mt">
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Marital Status"
                                                                    fullWidth
                                                                    value={policyHolder.status}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Smoker Status"
                                                                    fullWidth
                                                                    value={policyHolder.smoker_status}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-3">
                                                                <TextField
                                                                    type="text"
                                                                    label="Aggregator Id"
                                                                    fullWidth
                                                                    value={policyHolder.aggregator_id}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row mt p-2">
                                                            <div className="form-group col-md-6">
                                                                <label>Physical Address</label>
                                                                <address>
                                                                    {physicalAddress.street}
                                                                    <br/>
                                                                    {physicalAddress.suburb}
                                                                    <br/>
                                                                    {physicalAddress.city}
                                                                </address>
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label>Postal Address</label>
                                                                <address>
                                                                    {postalAddress.street}
                                                                    <br/>
                                                                    {postalAddress.suburb}
                                                                    <br/>
                                                                    {postalAddress.city}
                                                                </address>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPolicyHolder;
